import {safeGet} from "../utils";

export function renderScreenFingerprint(): string {
  return [
    safeGet(() => window.screen.width),
    safeGet(() => window.screen.height),
    safeGet(() => window.screen.colorDepth),
    safeGet(() => window.screen.pixelDepth),
    safeGet(() => window.screen.orientation.type),
  ].join('x');
}
